import { SKIP_WINNER_DESCRIPTION_CUSTOM_VICTORY_TITLE } from '../../../../../utils/constants/common'
import { getTeamLabelByNumber, getTeamNumberByLabel } from '../../utils/utils'

export default {
  // 'this' - $store
  byActionType: {},
  // 'this' - $store
  byEventType: {
    'START_PERIOD' ({ GamePeriod, ScoreHome, ScoreAway }) {
      const { hasGoldenSet, getFormats } = this
      const { count } = getFormats.matchFormat

      if (!hasGoldenSet) return

      const isGolden = Math.ceil(count / 2) <= Math.max(ScoreHome, ScoreAway)

      if (isGolden) this.setGoldenTypeToPeriod(GamePeriod)
    },
    'FINISH_GAME_INTERRUPTED' () {
      this.setIngameProperty({
        property: 'gameInterrupted',
        value: true
      })
    },
    'FINISH_GAME' (event) {
      const { GamePeriod } = event
      const { getMatchPeriods, getWinner } = this
      const { type } = getMatchPeriods[GamePeriod]

      if (this.getIngameData.gameInterrupted) {
        this.setCustomVictoryTitle(SKIP_WINNER_DESCRIPTION_CUSTOM_VICTORY_TITLE)
      }

      if (type === 'golden') {
        return {
          teamNumber: getTeamNumberByLabel(getWinner)
        }
      }

      this.setWinner(event)
    },
    'SET' (event) {
      const { GamePeriod, ScoreHome, ScoreAway, TeamNumber } = event
      const { type } = this.getMatchPeriods[GamePeriod]

      this.setIngameProperty({
        property: 'sets',
        value: {
          home: ScoreHome,
          away: ScoreAway
        }
      })

      this.setIngameProperty({
        property: 'score',
        value: {
          home: 0,
          away: 0
        }
      })

      if (type === 'golden') {
        this.setWinnerMutation(getTeamLabelByNumber(TeamNumber))
        this.translationToArchive()
      }
    }
    // 'ADJUST_SETS' (event) {
    //   const { EventCode, extra, TeamNumber, Playtime, Timestamp } = event
    //
    //   this.setIngameProperty({
    //     property: 'sets',
    //     value: {
    //       home: event.ScoreHome,
    //       away: event.ScoreAway
    //     }
    //   })
    // }
  },
  // 'this' - tradermode component instance
  // для кастомной логики отображения event
  eventTitles: {
    /**
     * @return {string}
     */
    'FINISH_GAME' (event) {
      const { GamePeriod, eventInfo, TeamNumber } = event
      const { title } = eventInfo
      const { getMatchPeriods, getWinner, homeTeamTitle, awayTeamTitle } = this
      const { type } = getMatchPeriods[GamePeriod]

      if (this.getIngameData.gameInterrupted) {
        return this.$t('trader.gameover')
      }

      if (type !== 'golden') {
        if (!TeamNumber) {
          return `${this.$t('trader.gameover')} / ${this.$t('trader.draw.capitalized')}`
        }

        const defaultTeamTitle = TeamNumber === 1 ? homeTeamTitle : awayTeamTitle

        return `${title} / ${defaultTeamTitle}`
      }

      const goldenTeamTitle = getWinner === 'home' ? homeTeamTitle : awayTeamTitle

      return `${this.$t('trader.gameover.golden')} / ${goldenTeamTitle}`
    },
    'ADJUST_POINTS' (event) {
      return this.$t('trader.adjust.points.title')
    },
    /**
     * @return {string}
     */
    'CANCEL' (event, relatedEvent) {
      const { homeTeamTitle, awayTeamTitle } = this
      const { eventInfo } = event
      const { title } = eventInfo
      const { EventCode, extra, TeamNumber } = relatedEvent
      const { team } = extra
      const notPointEvents = ['TIMEOUT', 'BALL_IN_GAME', 'FINISH_PERIOD']

      if (notPointEvents.includes(EventCode)) {
        return `${title}: ${this.getEventTitle(relatedEvent)}`
      }

      if (EventCode === 'POINT') {
        return `
          ${title}: 
          ${relatedEvent.eventInfo.title}, 
          ${extra[`points-${team}`]}, 
          ${TeamNumber === 1 ? homeTeamTitle : awayTeamTitle}
        `
      }

      return `${title}: ${this.getEventTitle(relatedEvent)}`
    }
  }
}
